import React from "react";

const JQuery_Hide_Show = () => {
  return (
    <div>
      <h1>JQuery_Hide_Show</h1>
      <p>Placeholder component for: "JQuery_Hide_Show"</p>
    </div>
  );
};

export default JQuery_Hide_Show;
